import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
/* components */
import {CardComponent} from './components/card/card.component';
import {TodolistComponent} from './components/todolist/todolist.component';
import {TabsetComponent} from './components/tabset/tabset.component';
import {TabContentComponent} from './components/tabset/tab-content/tab-content.component';
import {ProgressBarComponent} from './components/progress-bar/progress-bar.component';
import {FileTreeComponent} from './components/file-tree/file-tree.component';
import {SwitchComponent} from './components/switch/switch.component';
import {PellEditorComponent} from './components/pell-editor/pell-editor.component';
import {AlertComponent} from './components/alert/alert.component';
import {ProfileComponent} from './components/profile/profile.component';
import {UserService} from './services/user.service';
import {HTTP_INTERCEPTORS} from '../../../node_modules/@angular/common/http';
import {AdminHttpInterceptor} from './utils/admin.http.interceptor';
import {HttpErrorInterceptor} from './utils/error.interceptor';
import {AuthorityService} from './services/authority.service';
import {TranslateModule} from '@ngx-translate/core';
import {NavigatorUtils} from './utils/navigator.utils';
import {SpianalyticsService} from './services/spianalytics.service';
import {EchartsUtils} from './utils/echarts.utils';
import {AuthGuard} from './guards/auth.guard';
import {MessagesUtils} from './utils/messages.utils';
import {StatusPipe} from './pipes/status.pipe';
import {TooltipModule} from 'primeng/primeng';
import {CanAcessDirective} from './guards/can-access.Directive';
import {GsbUtils} from './utils/GsbUtils';
import {SpiPdfMakeService} from './services/spiPdfMake.service';
import {GsbQuantityNumberPipe} from "./pipes/GsbQuantityNumberPipe";
import {CentrePipe} from "./pipes/CentrePipe";
import {StockService} from './services/stock.service';
import {RegionService} from './services/region.service';
import {FarmerPipe} from "./pipes/FarmerPipe";
import {ProductPipe} from "./pipes/ProductPipe";
import {GsbDatePipe} from "./pipes/GsbDatePipe";
import {GsbDateTimePipe} from "./pipes/GsbDateTimePipe";
import {DocumentExportService} from './services/document-export.service';
import {DashboardQueryService} from './services/dashboard-query.service';
import {SpiEchartsUtils} from './services/spi.echarts.utils';
import {SpiUtils} from './services/spi.utils';
import {SpiChartsService} from './services/spi-charts.service';
import {ConverterUtils} from './services/converter.utils';
import {BlockUIModule} from 'ng-block-ui';
import {NowDirective} from './directives/now/now.directive';
import {ChartPieComponent} from '../pages/index/chart-pie/chart-pie.component';
import {ChartBarComponent} from '../pages/index/chart-bar/chart-bar.component';
import {NgxEchartsModule} from 'ngx-echarts';
import {ExportBonCommandeService} from './services/export-bon-commande.service';
import {ExportExcelService} from './services/export-excel.service';
import {ChartPivotTableComponent} from '../pages/index/chart-pivot-table/chart-pivot-table.component';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgxEchartsModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingBarHttpClientModule
  ],
  declarations: [
    CardComponent,
    FileTreeComponent,
    TodolistComponent,
    TabsetComponent,
    TabContentComponent,
    ProgressBarComponent,
    SwitchComponent,
    PellEditorComponent,
    AlertComponent,
    ProfileComponent,
    StatusPipe,
    GsbQuantityNumberPipe,
    CentrePipe,
    FarmerPipe,
    ProductPipe,
    GsbDatePipe,
    GsbDateTimePipe,
    CanAcessDirective,
    NowDirective,
    ChartPieComponent,
    ChartBarComponent,
    ChartPivotTableComponent
  ],
  exports: [
    CardComponent,
    FileTreeComponent,
    TodolistComponent,
    TabsetComponent,
    TabContentComponent,
    ProgressBarComponent,
    SwitchComponent,
    PellEditorComponent,
    AlertComponent,
    ProfileComponent,
    TranslateModule,
    TooltipModule,
    StatusPipe,
    GsbQuantityNumberPipe,
    CentrePipe,
    FarmerPipe,
    ProductPipe,
    GsbDatePipe,
    GsbDateTimePipe,
    CanAcessDirective,
    LoadingBarHttpClientModule,
    NowDirective,
    ChartPieComponent,
    ChartBarComponent,
    ChartPivotTableComponent
  ],
  providers: [
    UserService,
    RegionService,
    StockService,
    AuthorityService,
    SpianalyticsService,
    SpiPdfMakeService,
    NavigatorUtils,
    EchartsUtils,
    MessagesUtils,
    StatusPipe,
    GsbQuantityNumberPipe,
    CentrePipe,
    FarmerPipe,
    ProductPipe,
    GsbDatePipe,
    GsbDateTimePipe,
    AuthGuard,
    CanAcessDirective,
    GsbUtils,
    DatePipe,
    DecimalPipe,
    DocumentExportService,
    DashboardQueryService,
    SpiEchartsUtils,
    SpiChartsService,
    SpiUtils,
    ConverterUtils,
    ExportBonCommandeService,
    ExportExcelService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AdminHttpInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    }
  ]
})
export class SharedModule {
}
